export default __webpack_public_path__ + "static/media/Folder.9030921c.svg";